//war orginal PhoneInput.ts, siehe PhoneInput.ts factory fuer erklaerung...
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PhoneInput.html?raw';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import docu from './PhoneInputDocumentation.html?raw';
import aspect from 'dojo/aspect';
import { CountryCodeIti } from "../MultiLangEdit/TranslationsForm/TranslationsFormTypes";
import { AccessibilityLabelsHelper, ExtraHelpers } from "../../../more/Helpers";

//import TelInput = require("./plugin/intlTelInput.js");

class PhoneInputTelInput extends compose(_LabelInputBase) {
    templateString: any = template;

    protected inputNode: HTMLInputElement;
    protected errorMsgNode: HTMLLabelElement;

    validationMsgNodeContainer = "errorMsgNode";
    validationErrorMsgText: any = null;// "invalid phone number"
    errorMap: any = [window.translations['PersonData__phoneValidationMsg_invalid'], window.translations['PersonData__phoneValidationMsg_countryCode'], window.translations['PersonData__phoneValidationMsg_short'],
    window.translations['PersonData__phoneValidationMsg_long'], window.translations['PersonData__phoneValidationMsg_invalid']];

    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;

    iti_instance: any;

    // configuration options
    onlyCountries: Array<String> = new Array<String>();
    excludeCountries: Array<String> = new Array<String>();
    preferredCountries: Array<String> = new Array<String>();
    initialCountry: string;

    private dependecyPromise:Promise<void>|null;
    private wasInitialized: boolean = false;

    private is_safari: boolean = false;
    private safari_initVal: string = null;
    constructor(initialCountry?: CountryCodeIti) {
        super(...(arguments as unknown as []));
        const uAgent = navigator.userAgent.toLowerCase();
        if (/applewebkit/i.test(uAgent) == true && uAgent.includes("safari")) {
            //weil chrome und edge sich auch als safari zusaetzlich vorstellen muessen wir das auch ueberpruefen
            if (uAgent.includes("chrome/") == false && uAgent.includes("edg/") == false) {
                this.is_safari = true;
            }
        }
        this.dependecyPromise = ExtraHelpers.sideLoadResource(
            window.appRoot + "Content/intertelinput/intlTelInput.js", 'js'
        ).then(()=>{
            this.wasInitialized = true;
        });
        if (initialCountry) {
            this.initialCountry = initialCountry;
        }
    }
    focus() {
        this.inputNode.focus();
    }
    // events -----------------------------------START
    private _onChange_phoneInput(): void {
        let value = this.getDirtyValue();

        this.setValue(value);
    }

    private _onKeyUp_phoneInput(): void {
        let value = this.getDirtyValue();

        this.setValue(value);
    }

    // this.inputNode.addEventListener("countrychange", function () { // do something with iti.getSelectedCountryData() });
    // this.inputNode.addEventListener("close:countrydropdown", function () { });
    // this.inputNode.addEventListener("open:countrydropdown", function () { });

    // events -----------------------------------END
    // validattion -----------------------------START

    protected customValidation(): boolean {
        if (this.wasInitialized == false){
            return false; //wenn telinput.js nicht geladen hat, gibt es nichts zum validieren
        }

        let result: boolean = true;
        let errorCode: string;

        this.validationErrorMsgText = null;

        if (this.iti_instance.getNumber()) {

            if (this.iti_instance.isValidNumber() === false) {

                errorCode = this.iti_instance.getValidationError()
                this.validationErrorMsgText = this.errorMap[errorCode];
                result = false
            }

        }

        if (this.isMandatory && this.iti_instance.getNumber() == "") {
            this.validationErrorMsgText = null;// this.translate('PersonData__phoneValidationMsg_empty');
            result = false;


        }

        return result;
    }


    // validation ---------------------------------END
    // config options getter und setter -------------START
    getInitialCountry(): string {
        if (this.initialCountry) {
            return this.initialCountry;
        }

        return "";
    }

    setInitialCountry(country: string): void {
        this.initialCountry = country;
    }

    setOnlyCountries(onlyCountries: Array<String>): void {
        this.onlyCountries = onlyCountries;
        this._initInterTelInput();
    }

    getOnlyCountries(): Array<String> {
        if (this.onlyCountries) {
            return this.onlyCountries;
        }
        return undefined;
    }

    setExcludeCountries(onlyCountries: Array<String>): void {
        this.onlyCountries = onlyCountries;
        this._initInterTelInput();
    }
    getExcludeCountries(): Array<String> {
        if (this.onlyCountries) {
            return this.onlyCountries;
        }
        return undefined;
    }

    setPreferredCountries(onlyCountries: Array<String>): void {
        this.onlyCountries = onlyCountries;
        this._initInterTelInput();
    }
    getPreferredCountries(): Array<String> {
        if (this.onlyCountries) {
            return this.onlyCountries;
        }
        return undefined;
    }

    // config options getter und setter -------------END


    // initialisierung

    private _initInterTelInput(): void {
        let dependencyScriptUrl:string = window.appRoot + "Content/intertelinput/utils.js";
        let settings = {
            // allowDropdown: false,
            // autoHideDialCode: false,
            // autoPlaceholder: "off",
            customContainer: "w3-block",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            //formatOnDisplay: true,
            //geoIpLookup: function(callback) {
            //  $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
            //    var countryCode = (resp && resp.country) ? resp.country : "";
            //    callback(countryCode);
            //  });
            //},
            // hiddenInput: "full_number",
            // initialCountry: "auto",
            // localizedCountries: { 'de': 'Deutschland' },
            // nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            // placeholderNumberType: "MOBILE",
            // preferredCountries: [ 'de', 'it'],
            // separateDialCode: true,
            utilsScript: dependencyScriptUrl,
        };


        if (!this.initialCountry){
            //aus settings
            let globalSettings = this.getModule("TelInput") as any;
            if (globalSettings && typeof globalSettings == 'object' && globalSettings.hasOwnProperty("initialCountry")){
                let initialCountryGlobal:string = globalSettings["preferredCountry"] as string;
                if (initialCountryGlobal && typeof initialCountryGlobal == 'string'){
                    if (initialCountryGlobal.trim() != "" && initialCountryGlobal.startsWith("#") == false){
                        this.initialCountry = initialCountryGlobal;
                    }
                }
            }
            //evtl. andere settings auch hier reinladen falls bedarf, dadurch dass das zeug bis jetzt nicht gebraucht worden ist, lassen wir das mal
        }


        if (this.initialCountry) {
            settings["initialCountry"] = this.initialCountry;
        }

        if (this.excludeCountries.length > 0) {
            settings["excludeCountries"] = this.excludeCountries;
        }

        if (this.onlyCountries.length > 0) {
            settings["onlyCountries"] = this.onlyCountries;
        }

        if (this.preferredCountries.length > 0) {
            settings["preferredCountries"] = this.onlyCountries;
        }


        this.dependecyPromise.then(async ()=>{ //wird im ctor gesetzt
            let presetVal = false;
            if (this.is_safari){
                //webkit bug, util script wird nicht geladen im telInput.js script in safari
                await ExtraHelpers.sideLoadResource(dependencyScriptUrl, 'js');
                presetVal = true;
            }
            this.iti_instance = window.intlTelInput(this.inputNode, settings);
            if (presetVal == true){
                if (this.safari_initVal != null){
                    let newVal = this.safari_initVal;
                    this.iti_instance.setNumber(newVal);
                    this.safari_initVal = null;
                    if (newVal.startsWith("+")){
                        this.showToast(this.translate("SafariBug_TelInputJs"), "fab fa-safari");
                        this.setReadonly(true);
                    }
                }
            }
        });

    }

    // Value -------------------------------------START

    protected getDirtyValue(): string {
        let dirty = this.iti_instance.getNumber();
        if (dirty) {
            return dirty;
        }
        return null;
    }

    private _afterCountryChangeHandle: dojo.Handle = null;

    protected setInputValue(value: string): void {
        if (value) {
            const setVal = ()=>{
                // im setNumber kann ein Countrychange ausgelöst worden sein! dann ist die Nummer wieder auf null gesetzt worden!!
                if (typeof this.iti_instance != 'undefined') {
                    this._afterCountryChangeHandle = aspect.after(this.iti_instance, "_triggerCountryChange", lang.hitch(this, this._retryValueAfterCountryChange, value));
                    this.iti_instance.setNumber(value);
                } else {
                    //race condition safari - yay
                    this.safari_initVal = value;
                }

            }
            this.dependecyPromise.then(setVal.bind(this));
        }
    }

    private _retryValueAfterCountryChange(value: string) {

        if (this.getDirtyValue() == null && !!value) {
            this.setValue(value);
        }

        if (this._afterCountryChangeHandle) this._afterCountryChangeHandle.remove();
    }

    // iti_instance public methods --------------------------------START

    //Remove the plugin from the input, and unbind any event listeners.
    destroy(): void {
        this.iti_instance.destroy()
    }

    // Get the extension from the current number. Requires the utilsScript option.
    getExtension(): string {
        if (this.iti_instance.getExtension()) {
            return this.iti_instance.getExtension();
        }
        return null;
    }

    // Returns an integer, which you can match against the various options in the global enum intlTelInputUtils.numberType e.g. if (numberType === intlTelInputUtils.numberType.MOBILE) {}
    getNumberType(): number {
        if (this.iti_instance.getNumberType()) {
            return this.iti_instance.getNumberType()
        }
        return null;
    }

    // Get the country data for the currently selected flag. { name: "Afghanistan (‫افغانستان‬‎)", iso2: "af", dialCode: "93" }
    getSelectedCountryData(): object {
        if (this.iti_instance.getSelectedCountryData()) {
            return this.iti_instance.getSelectedCountryData()
        }
        return null;
    }

    isValidNumber(): boolean {
        return this.iti_instance.isValidNumber();
    }

    // Change the country selection (e.g. when the user is entering their address).
    setCountry(iso2: string): void {
        this.iti_instance.setCountry(iso2);
    }

    // Get the current number in the given format (defaults to E.164 standard). different formats are available: let number = iti.getNumber(intlTelInputUtils.numberFormat.E164);
    getNumber(): string {
        let value = this.iti_instance.getNumber();
        if (value) {
            return value;
        }
        return null;
    }

    // types: "FIXED_LINE", "MOBILE",  "FIXED_LINE_OR_MOBILE",    "TOLL_FREE",    "PREMIUM_RATE",    "SHARED_COST",    "VOIP",    "PERSONAL_NUMBER",    "PAGER",    "UAN",    "VOICEMAIL",    "UNKNOWN"
    setPlaceholderNumberType(numberType: string): void {

        this.dependecyPromise.then(()=>{
            this.iti_instance.setPlaceholderNumberType(numberType);
        });

    }

    // iti_instance public methods ------------------------------------END

    setValidationEnabled(bEnable?: boolean) {
        this.validationEnabled = bEnable !== false;

        if (this.validationEnabled != true) {
            this._setValidationResultStyle();
        }
    }


    /////////////////////////////////////////////////////////

    protected _setMandatoryStyle(): void {

        var bHighlight = false;
        if (this._manualHighlightOverride != true) {
            bHighlight = this.highlightOnEmptyValue == true && (this.getValue() == null || this.getValue() == "");
        } else {
            bHighlight = this._manualHighlightOverride;

        }


        console.log("highlight edit manual?", this._manualHighlightOverride, bHighlight);

        if (bHighlight) {
            this.UiModder.domClass.add(this.labelNode, "w3-text-red");
            this.UiModder.domClass.add(this.inputNode, "w3-border-red w3-pale-red");
        } else {
            this.UiModder.domClass.remove(this.labelNode, "w3-text-red");
            this.UiModder.domClass.remove(this.inputNode, "w3-border-red w3-pale-red");
        }
    }

    protected _setReadonlyStyle(): void {
        if (this.isReadonly === true) {
            this.UiModder.domAttr.set(this.inputNode, "disabled", true);

        } else {
            this.UiModder.domAttr.remove(this.inputNode, "disabled");
        }

        if (this.labelNode) {
            this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }
    }
    // Label

    //wir emiten den dropdown state um evtl. coole overflow probleme zu handlen
    private _onHandle_DropDown(dropDownState: boolean) {
        this.emit("countryDropDown", dropDownState);
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // Dojo

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._initInterTelInput();

        this.inputNode.addEventListener("countrychange", function () { // scope - input
            this.value = null;
            var event = new Event('change', {
                bubbles: false,
                cancelable: true,
            });

            this.dispatchEvent(event);
        });

        this.inputNode.addEventListener('open:countrydropdown', lang.hitch(this, this._onHandle_DropDown, true));
        this.inputNode.addEventListener('close:countrydropdown', lang.hitch(this, this._onHandle_DropDown, false));

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "telInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PhoneInputTelInput);
